import {
  OPEN_REVIEW_DIALOG,
  CLOSE_REVIEW_DIALOG,
  DELETE_REVIEW,
  CREATE_REVIEW,
  EDIT_REVIEW,
  UPDATE_REVIEW_DATA,
  REVIEW_REQUEST_ERROR,
} from '../actions';

export default (state, action) => {
  if (!state) {
    return {
      open: false,
      myReview: null,
      pendingRequest: false,
      userReviews: null,
      reviewType: null,
    };
  }

  switch (action.type) {
    case CREATE_REVIEW:
      return {
        ...state,
        pendingRequest: { type: 'create' },
        requestError: false,
      };
    case EDIT_REVIEW:
      return {
        ...state,
        pendingRequest: { type: 'edit' },
        requestError: false,
      };
    case DELETE_REVIEW:
      return {
        ...state,
        pendingRequest: { type: 'delete' },
        requestError: false,
      };
    case OPEN_REVIEW_DIALOG:
      return {
        ...state,
        open: true,
      };
    case CLOSE_REVIEW_DIALOG:
      return {
        ...state,
        open: false,
        requestError: false,
      };
    case UPDATE_REVIEW_DATA:
      return {
        ...state,
        userReviews: action.userReviews,
        reviewType: action.reviewType,
        pendingRequest: false,
      };
    case REVIEW_REQUEST_ERROR:
      return {
        ...state,
        requestError: true,
        pendingRequest: false,
      };
    case 'ROUTE_LOADED': {
      // Clear the "override" data on page reload / change
      // NOTE: This is a hack and should be avoided
      return {
        ...state,
        userReviews: null,
        reviewType: null,
      };
    }
    default:
  }

  return state;
};
